<template>
  <van-row class="index-main">
    <van-row class="head">
      <van-row class="menu">
        <van-row class="row-box">
          <van-col span="8" class="logobox">
            <img src="../assets/images/logo.png" class="logo" />
          </van-col>
          <van-col span="16" class="btn-box">
            <!-- <van-button type="info" size="small" class="rebtn" @click="goRegister">{{$t('m.Registernow')}}</van-button> -->
            <img src="../assets/images/huusu.png" class="huiimg" @click="showPopupb" />
          </van-col>
        </van-row>
      </van-row>
    </van-row>
    <van-popup v-model="showPopup" position="top" class="popupcl">
      <van-row class="close"><img src="../assets/images/drg.png" @click="showPopup = false"/></van-row>
      <van-collapse v-model="activeName" accordion>
        <van-collapse-item @click.native="routePage('/')" :title="$t('m.home')" name="1" disabled></van-collapse-item>
        <van-collapse-item :title="$t('m.about')" name="2">
          <!-- <van-row class="menuson" @click="goPage('legalDocument')">{{$t('m.LegalDocument')}}</van-row>
          <van-row class="menuson" @click="goPage('partners')">{{$t('m.Partners')}}</van-row>
          <van-row class="menuson" @click="goPage('contactUs')">{{$t('m.ContactUs')}}</van-row> -->
          <van-row class="menuson" @click.native="routePage('qualification')">{{$t('m.Qualification')}}</van-row>
        </van-collapse-item>
        <!-- <van-collapse-item :title="$t('m.Trade')" disabled name="3" @click.native="goPage('trader')"></van-collapse-item> -->
        <van-collapse-item :title="$t('m.Trade')" disabled name="3" @click.native="goLogin"></van-collapse-item>
        <!-- <van-collapse-item :title="$t('m.OTC')" disabled name="4"></van-collapse-item> -->
        <!-- <van-collapse-item :title="$t('m.IEO')" disabled name="5" @click.native="goPage('icopg')" ></van-collapse-item> -->
        <van-collapse-item :title="$t('m.News')" name="6">
          <van-row class="menuson" @click="goPage('Announcement')">{{$t('m.Announcement')}}</van-row>
          <van-row class="menuson" @click="goPage('IndustryNews')">{{$t('m.IndustryNews')}}</van-row>
        </van-collapse-item>
        <!-- <van-collapse-item :title="$t('m.Assets')" disabled name="7" @click.native="goLogin"></van-collapse-item> -->
      </van-collapse>
      <van-row class="line"></van-row>
      <van-row class="lang-box">
        <van-col span="6" class="langitem" @click.native="goen('en-US')">English</van-col>
        <!-- <van-col span="6" class="langitem" @click.native="goen('zh')">简体中文</van-col> -->
        <van-col span="6" class="langitem" @click.native="goen('zhf')">繁體</van-col>
        <van-col span="6" class="langitem" @click.native="goen('kn')">한국어</van-col>
        <van-col span="6" class="langitem" @click.native="goen('ri')">日本語</van-col>
      </van-row>
      <!-- <van-row class="lang-box">
        <van-col span="6" class="langitem" @click.native="goen('ri')">日本語</van-col>
      </van-row> -->
    </van-popup>
  </van-row>
  <!-- <div class="head-box" id="nav" :style="{background:isIndex?'none':'#1b1b1b'}">
    <div class="menu-box">
      <div class="logo-box"><router-link to="/" ><img src="../assets/images/logo.png" alt="" /></router-link></div>
      <ul>
        <li style="margin-left:100px" :class="{active:currroute === 'legalDocument' || currroute === 'partners' || currroute === 'contactUs'}">
          <el-dropdown placement="bottom-start" >
            <span class="el-dropdown-link cursor-pointer" style="font-size:16px" :style="{color:(currroute === 'legalDocument' || currroute === 'partners' || currroute === 'contactUs')?'#ffbd2a':'#fff'}">
              {{$t('m.about')}}<i class="el-icon-arrow-down el-icon--right" :style="{color:(currroute === 'legalDocument' || currroute === 'partners' || currroute === 'contactUs')?'#ffbd2a':'#fff'}"></i>
            </span>
            <el-dropdown-menu slot="dropdown" style="margin-top:4px">
              <el-dropdown-item>{{$t('m.Qualification')}}</el-dropdown-item>
              <el-dropdown-item @click.native="hrefGoods('legalDocument', 1)">{{$t('m.LegalDocument')}}</el-dropdown-item>
              <el-dropdown-item @click.native="hrefGoods('partners')">{{$t('m.Partners')}}</el-dropdown-item>
              <el-dropdown-item @click.native="hrefGoods('contactUs')">{{$t('m.ContactUs')}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
        <li :class="{active:currroute === 'trader'}" @click="hrefGoods('trader')">{{$t('m.Trade')}}</li>
        <li @click="hrefOtc()">{{$t('m.OTC')}}</li>
        <li :class="{active:currroute === 'ico' || currroute === 'icoDetails' || currroute === 'ieoDetailsETH'}" @click="hrefGoods('ico')">{{$t('m.IEO')}}</li>
        <li :class="{active:currroute === 'news'}">
          <el-dropdown placement="bottom-start">
            <span class="el-dropdown-link cursor-pointer" style="font-size:16px" :style="{color:currroute === 'news'?'#ffbd2a':'#fff'}" >
             {{$t('m.News')}}<i class="el-icon-arrow-down el-icon--right" :style="{color:currroute === 'news'?'#ffbd2a':'#fff'}"></i>
            </span>
            <el-dropdown-menu slot="dropdown" style="margin-top:4px">
              <el-dropdown-item @click.native="hrefGoods('news',1)">{{$t('m.Announcement')}}</el-dropdown-item>
              <el-dropdown-item @click.native="hrefGoods('news',2)">{{$t('m.IndustryNews')}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
        <li :class="{active:currroute === 'wallet'}" @click="hrefGoods('wallet')">{{$t('m.Assets')}}</li>
      </ul>
      <div class="langc">
        <el-dropdown>
          <span class="el-dropdown-link cursor-pointer" style="font-size:16px" >
            {{$t('m.chinaz')}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" style="margin-top:4px">
            <el-dropdown-item @click.native="goen('en-US')">English</el-dropdown-item>
            <el-dropdown-item @click.native="goen('zhf')">中文繁体</el-dropdown-item>
            <el-dropdown-item @click.native="goen('kn')">한국어</el-dropdown-item>
            <el-dropdown-item @click.native="goen('ri')">日本語</el-dropdown-item>
            <el-dropdown-item @click.native="goen('yue')">Việt nam</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="lg-box">
        <template v-if="isLogin" >
          <el-dropdown style="margin-top:5px">
          <img src="../assets/images/active.png" alt="" width="36" height="36" />
          <el-dropdown-menu slot="dropdown" >
            <el-dropdown-item @click.native="hrefGoods('myAccount')">{{$t('m.Personalcenter')}}</el-dropdown-item>
            <el-dropdown-item @click.native="exitlogin">{{$t('m.logout')}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        </template>
        <template v-else>
          <span @click="openFlag = true,stopMove()">{{$t('m.login')}}</span>
          <span @click="openregisterFlag = true,stopMove()" style="margin:0 5px 0 15px;display:inline-block;width:auto;padding:0 14px;height:30px;border:1px solid #FFF;line-height:30px;border:1px solid rgba(255,189,42,0.5);border-radius:4px;" >{{$t('m.register')}}</span>
        </template>
      </div>
    </div>
    <div class="linetop" v-show="!isIndex"></div>
    <loginPage :openFlag="openFlag" @childFn="parentFn" v-if="openFlag"/>
    <registerPage :openFlag="openregisterFlag" @childFnregist="regparentFn" v-if="openregisterFlag"/>
    <changePwPage :openFlag="changePwFlag" @childPwfn="changePwFn" v-if="changePwFlag"/>
  </div> -->
</template>


<script>
import BaseConfig from '@/common/baseConfig';
import publicAPI from '@/api/public';
import enduserAPI from '@/api/enduser';
import Bus from "@/common/Bus"
import { Col, Row, Popup, Collapse, CollapseItem, Button   } from 'vant';
export default {
  name: 'headPage',
  components: {
    [Col.name]: Col ,
    [Button.name]: Button ,
    [Row.name]: Row ,
    [Popup.name]: Popup ,
    [Collapse.name]: Collapse ,
    [CollapseItem.name]: CollapseItem ,
  },
  data () {
    return {
      activeName:'2',
      currroute: 'home',
      isLogin: false,
      showPopup: false,
      isIndex: false,
      openFlag: false,
      openregisterFlag: false,
      changePwFlag: false,
      menuKey: 1,
      // imgon:require('../assets/images/medium-circle-fill.png'),
    }
  },
  watch: {
    $route: {
      handler: function (val) {
        this.currroute = val.name;
        let payload = sessionStorage.getItem('payload');
        if(payload!=='' && payload !== 'undefined' && payload !== null){
          this.isLogin = true
        }else {
          this.isLogin = false
          if(this.$route.params.type === 0){
            this.openFlag = true
          }
        }
        if(val.name === 'index') {
          this.isIndex = true
        }else {
          this.isIndex = false
        }
      },
      deep: true
    }
  },
  mounted () {
    // this.getcur()
    // this.getprofile()
    window.addEventListener('scroll',this.handleScroll,true)
    Bus.$on("ieoOpenlogin", (val) => {    //取  Bus.$on
      if(val === 1){
        this.openFlag = true
      } else {
        this.openFlag = false
      }
      this.stopMove()
    });
    Bus.$on("ieoOpenreg", (val) => {    //取  Bus.$on
      if(val === 1){
        this.openregisterFlag = true
      } else {
        this.openregisterFlag = false
      }
      this.stopMove()
    });
  },
  methods: {
    routePage(value) {
      this.showPopup = false
      this.$router.push(value)
    },
    goPage(value) {
      console.log(value)
      window.location.href = BaseConfig[value]
    },
    goRegister() {
      window.location.href = BaseConfig.REGIST_URL
    },
    goLogin() {
      window.location.href = BaseConfig.LOGIN_URL
    },
    showPopupb() {
      this.showPopup = true;
    },
    goen(val){
      this.$i18n.locale = val;
      Bus.$emit("lang", val)
      this.showPopup = false
      localStorage.setItem('currlocale', val)
    },
    hrefOtc () {
      const origin = window.location.origin;
      if(origin.indexOf('qa.rtdream.cn') !=-1){
        window.open('http://qa.rtdream.cn:7777/otc/#/index');
      } else {
        window.open('http://cocp.ltd/otc/#/index');
      }
    },
    changePwFn(payload) {
      this.Move()
      this.changePwFlag = payload.flag
      if(payload.hasOwnProperty('openlogin')) {
        this.openFlag = payload.openlogin
        this.stopMove()
      }
    },
    getprofile(){
      enduserAPI.getprofile().then(({ Caption, id, payments, BindTel, BindMail, CountryTel, CountryCode, VerifyEndUserDetail, subaccts, UplineDirect }) => {
        this.isLogin = true
        const parsobj = {
          flag: false,
          phone: BindTel
        };
        sessionStorage.setItem('payload', JSON.stringify(parsobj));
        sessionStorage.setItem('UplineDirect', UplineDirect);
      });
    },
    handleScroll(e){
      if(this.$route.path === '/') {
        if(document.documentElement.scrollTop > 100) {
          this.isIndex = false
        } else {
          this.isIndex = true
        }
      }
    },
    //停止页面滚动
    stopMove(){
      let m = function(e){e.preventDefault();};
      document.body.style.overflow='hidden';
      document.addEventListener("touchmove",m,{ passive:false });//禁止页面滑动
    },
    //开启页面滚动
    Move(){
      let m =function(e){e.preventDefault();};
      document.body.style.overflow='';//出现滚动条
      document.removeEventListener("touchmove",m,{ passive:true });
    },
    exitlogin() {
      sessionStorage.setItem('payload','');
      let keys = document.cookie.match(/[^ =;]+(?=\=)/g);  
      if(keys) {  
        for(var i = keys.length; i--;)  
          document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()  
      }
      this.isLogin = false
      if(this.$route.path === '/wallet' || this.$route.path === '/myAccount') {
        this.$router.push({name:'index'})
      }

    },
    getcur(){
      publicAPI.getcur().then(({ list }) => {
        localStorage.setItem('curData', JSON.stringify(list))          
      });
    },
    parentFn(payload) {
      this.Move()
      if(payload.hasOwnProperty('phone')){
        this.loginphone = payload.phone.replace(/^(\d{3})\d{4}(\d+)/,"$1****$2");
        this.isLogin = true
        this.openFlag = payload.flag;
        sessionStorage.setItem('payload', JSON.stringify(payload));
      }else if(payload.hasOwnProperty('openrig')) {
        this.openregisterFlag = true
        this.stopMove()
        this.openFlag = payload.flag
      }else if(payload.hasOwnProperty('openchangepw')) {
        this.changePwFlag = true
        this.stopMove()
        this.openFlag = payload.flag
      }else {
        this.openFlag = payload
      }
    },
    regparentFn(payload) {
      this.Move()
      this.openregisterFlag = payload.flag
      if(payload.hasOwnProperty('phone')) {
        // this.loginphone = payload.phone.replace(/^(\d{3})\d{4}(\d+)/,"$1****$2");
        this.isLogin = true
      } else if(payload.hasOwnProperty('openlogin')) {
        this.openFlag = payload.openlogin
        this.stopMove()
        this.openregisterFlag = false
      }

      // if(payload.type===2) {
      //   this.openFag = true;
      // }
    },
    gotd(){
      window.open(BaseConfig.LOGIN_URL);
    },
    registered() {
        window.open(BaseConfig.REGIST_URL);
    },
    hrefGoods (href,label) {
      if (href === 'wallet') {
        let payload = sessionStorage.getItem('payload');
        console.log(payload)
        if(!(payload!=='' && payload !== 'undefined' && payload !== null)){
          this.openFlag = true
          return
        }
      }
      this.$router.push({
        name: href,
        params: {
          label: label
        }
      })
    },
    hrefwai (href) {
      window.open(href);
    },

  }
}
</script>
<style lang="stylus">
.van-overlay{
    background-color: rgba(0,0,0,.2)!important;
}
.van-collapse-item__title .van-cell__right-icon::before {
    transform: rotate(0deg)!important;
}
.van-collapse-item__title--expanded .van-cell__right-icon::before {
    transform: rotate(90deg)!important;
}
.popupcl .van-cell {
  background-color: rgba(40, 43, 56, 1)!important;
  color: #AAAAAA!important;
  font-size:.52rem!important
  padding: 6px 16px!important;
}
.van-collapse-item--border::after{
  border-top: none!important
}
.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
    border-width: 0!important;
}
.van-collapse-item__title--disabled, .van-collapse-item__title--disabled .van-cell__right-icon {
    color: #AAAAAA;
    font-size:.52rem!important
}
.van-collapse-item__content {
    padding: 0 32px!important;
    color: #969799;
    font-size: 14px;
    line-height: 1.5;
    background-color: rgba(40, 43, 56, 1)!important;
}
.van-cell::after {
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    right: 16px;
    bottom: 0;
    left: 16px;
    border-bottom: none!important;
    -webkit-transform: scaleY(.5);
    transform: scaleY(.5);
}
</style>
<style  lang="stylus" scoped>
  @import "~common/stylus/headPage.styl";
</style>



// WEBPACK FOOTER //
// src/components/headPage.vue